var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fluid-container footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"}),_c('div',{staticClass:"col-11"},[_c('p',[_vm._v(_vm._s(_vm.$t('msg.copyright')))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }